import { useBrand } from './brand-context';
import { BRAND_COPY } from './copy';
import type { BrandCopy } from './copy';

const useBrandCopy = (): BrandCopy => BRAND_COPY[useBrand().brand];

export { useBrandCopy };
